import { Controller } from "@hotwired/stimulus"

// Debounced refresh of the cache hygiene panel while editing a draft prompt body.
export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 450 },
  }

  connect() {
    this.timer = null
    this.abortController = null
  }

  disconnect() {
    this.clearTimer()
    this.abortInFlight()
  }

  schedule() {
    this.clearTimer()
    this.timer = window.setTimeout(() => this.refresh(), this.delayValue)
  }

  clearTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer)
      this.timer = null
    }
  }

  abortInFlight() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = null
    }
  }

  panelElement() {
    return this.element.querySelector('[data-prompt-cache-hygiene-preview-target="panel"]')
  }

  async refresh() {
    if (!this.hasUrlValue) return

    const textarea = this.element.querySelector(
      '[data-prompt-cache-hygiene-preview-target="bodyField"]'
    )

    let panelEl = this.panelElement()
    if (!panelEl) return

    const tokenMeta = document.querySelector('meta[name="csrf-token"]')
    const token = tokenMeta ? tokenMeta.getAttribute("content") : ""

    const bodyText = textarea ? textarea.value : ""

    this.abortInFlight()
    const controller = new AbortController()
    this.abortController = controller

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        signal: controller.signal,
        headers: {
          Accept: "text/html",
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest",
          ...(token ? { "X-CSRF-Token": token } : {}),
        },
        body: new URLSearchParams({ authenticity_token: token || "", body: bodyText }),
      })

      if (!response.ok) {
        console.warn("[prompt-cache-hygiene-preview] preview failed:", response.status)
        return
      }

      const raw = await response.text()
      if (controller.signal.aborted) return

      panelEl = this.panelElement()
      if (!panelEl) return

      const trimmed = raw.trim()
      const doc = new DOMParser().parseFromString(trimmed, "text/html")
      const root = doc.body.firstElementChild
      if (root) panelEl.replaceWith(root)
    } catch (e) {
      if (e.name !== "AbortError") console.warn("[prompt-cache-hygiene-preview]", e)
    }
  }
}
